import React from "react";
import { Avatar, Box, Container, Grid, Paper, Typography } from "@mui/material";

import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PaidIcon from "@mui/icons-material/Paid";
import BadgeIcon from "@mui/icons-material/Badge";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ShieldIcon from "@mui/icons-material/Shield";
import GppGoodIcon from "@mui/icons-material/GppGood";
import ApartmentIcon from "@mui/icons-material/Apartment";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import GroupsIcon from "@mui/icons-material/Groups";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SchoolIcon from "@mui/icons-material/School";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import StorefrontIcon from "@mui/icons-material/Storefront";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PolicyIcon from "@mui/icons-material/Policy";
import SecurityIcon from "@mui/icons-material/Security";

import { sectionSubtitleSx, sectionTitleSx } from "./homeStyles";

function HomeAudience() {
    const audience = [
        { icon: BusinessCenterIcon, title: "Бухгалтерия" },
        { icon: PaidIcon, title: "Финансовые подразделения" },
        { icon: BadgeIcon, title: "Кадровые службы" },
        { icon: FactCheckIcon, title: "Внутренний аудит" },
        { icon: ShieldIcon, title: "Комплаенс и контроль" },
        { icon: GppGoodIcon, title: "Экономическая безопасность" },
        { icon: ApartmentIcon, title: "Госорганы и квазигоссектор" },
        { icon: CorporateFareIcon, title: "Национальные компании" },
        { icon: GroupsIcon, title: "Холдинги и филиальные структуры" },
        { icon: AccountBalanceIcon, title: "Организации с бюджетным финансированием" },
        { icon: SchoolIcon, title: "Образовательные организации" },
        { icon: LocalHospitalIcon, title: "Медицинские организации" },
        { icon: StorefrontIcon, title: "Организации с аутсорсингом бухгалтерии" },
        { icon: VerifiedUserIcon, title: "Службы внутреннего контроля" },
        { icon: PolicyIcon, title: "Внешний и финансовый аудит" },
        { icon: SecurityIcon, title: "Надзорные и проверяющие органы" },
    ];

    return (
        <Box sx={{ py: { xs: 6, md: 8 }, bgcolor: "white" }}>
            <Container maxWidth="xl">
                <Box textAlign="center" sx={{ mb: { xs: 4, md: 5 } }}>
                    <Typography variant="h3" sx={sectionTitleSx}>
                        Для кого подходит Qarzhy
                    </Typography>

                    <Typography sx={{ ...sectionSubtitleSx, maxWidth: 900 }}>
                        Qarzhy подходит для организаций, которым важно быстро
                        проверять выплаты, контролировать кадровые и бухгалтерские
                        данные, выявлять расхождения и снижать риск ошибок,
                        злоупотреблений и финансовых нарушений.
                    </Typography>
                </Box>

                <Grid container spacing={2.25}>
                    {audience.map((item) => {
                        const Icon = item.icon;

                        return (
                            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={item.title}>
                                <Paper
                                    elevation={0}
                                    sx={{
                                        p: { xs: 2, md: 2.4 },
                                        borderRadius: 3,
                                        border: "1px solid rgba(148, 163, 184, 0.18)",
                                        bgcolor: "#ffffff",
                                        boxShadow: "0 10px 26px rgba(15, 23, 42, 0.05)",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.4,
                                        height: "100%",
                                        transition:
                                            "transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease",
                                        "&:hover": {
                                            transform: "translateY(-3px)",
                                            boxShadow: "0 16px 32px rgba(15, 23, 42, 0.10)",
                                            borderColor: "rgba(37,99,235,0.22)",
                                        },
                                    }}
                                >
                                    <Avatar
                                        sx={{
                                            width: { xs: 42, md: 48 },
                                            height: { xs: 42, md: 48 },
                                            bgcolor: "rgba(37,99,235,0.10)",
                                            flexShrink: 0,
                                        }}
                                    >
                                        <Icon
                                            color="primary"
                                            sx={{
                                                fontSize: { xs: 22, md: 24 },
                                            }}
                                        />
                                    </Avatar>

                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            color: "#0f172a",
                                            fontSize: { xs: "0.92rem", md: "0.98rem" },
                                            lineHeight: 1.35,
                                        }}
                                    >
                                        {item.title}
                                    </Typography>
                                </Paper>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
}

export default HomeAudience;